import { render, staticRenderFns } from "./ThanksPage.vue?vue&type=template&id=2803aac3&scoped=true"
import script from "./ThanksPage.vue?vue&type=script&lang=js"
export * from "./ThanksPage.vue?vue&type=script&lang=js"
import style0 from "./ThanksPage.vue?vue&type=style&index=0&id=2803aac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2803aac3",
  null
  
)

export default component.exports